/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class DriverViolation{
  violationId:number;
  violationDate:string;
  violationTime:string;
  fakeViolationTime:string;
  violationArea:string;
  attachment:string;
  pointsExpirationDate:string;
  referenceID:string;
  violationPoints:number;
  driverId:number;
  violationDefinitionId:number;
  classification:string;
  type:string;
  description:string;
  points:number;
  locationId:number;
  locationName:string;
  locationTypeId:number;
  siteId:number;
  siteName:string;
  violationComment:string;
  commentBeChanged:boolean;
}
